import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Conversation as ConversationType } from "types/Conversation";
import ConversationForm from "./ConversationForm";

function Conversation() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any =
    useItem<ConversationType>("conversations", id, {
      populate: [
        "content",
        "content.category",
        "content.category.logo",
        "providerProfile",
        "providerProfile.avatar",
        "providerProfile.companyLogo",
        "applicantProfile",
        "applicantProfile.avatar",
        "applicantProfile.companyLogo",
        "content.images",
      ],
    });

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/conversations");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (values: any) => {
      const newValues = { ...values };

      try {
        if (newValues.id) {
          await updateItem(newValues.id, newValues);
        } else {
          await saveItem(newValues);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <ConversationForm onSubmit={onSubmit} conversation={item} />
  );
}

export default Conversation;
